module.exports = __webpack_public_path__ + "static/img/weboar_logo.10dc48e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/weboar_logo.svg
// module id = XBDW
// module chunks = 1